const LEGACY_TOKEN_KEY = 'meowmi-admin-token'

/**
 * Phase B1：admin token 主要存在 httpOnly cookie（瀏覽器自動帶 credentials: 'include'），
 * 不再依賴 JS 讀 sessionStorage（防 XSS 偷 token）。
 * 但保留 sessionStorage fallback header — 過渡期讓舊登入狀態不需重登。
 */
export function getAdminHeaders() {
  const legacy = typeof window !== 'undefined' ? sessionStorage.getItem(LEGACY_TOKEN_KEY) : null
  return {
    'Content-Type': 'application/json',
    ...(legacy ? { 'x-admin-token': legacy } : {}),
  }
}

// fetch wrapper：強制 credentials: 'include' 確保 admin cookie 帶過去
const adminFetch = (url, opts = {}) =>
  fetch(url, { credentials: 'include', ...opts })

export async function fetchArtworks() {
  const res = await fetch('/api/artworks')
  if (!res.ok) throw new Error('載入作品失敗')
  return res.json()
}

export async function createArtworks(artworks) {
  const res = await adminFetch('/api/artworks', {
    method: 'POST',
    headers: getAdminHeaders(),
    body: JSON.stringify({ artworks }),
  })
  if (!res.ok) throw new Error('新增作品失敗')
  return res.json()
}

export async function updateArtworkApi(id, updates) {
  const res = await adminFetch(`/api/artworks/${id}`, {
    method: 'PATCH',
    headers: getAdminHeaders(),
    body: JSON.stringify(updates),
  })
  if (!res.ok) throw new Error('更新作品失敗')
  return res.json()
}

export async function deleteArtworkApi(id) {
  const res = await adminFetch(`/api/artworks/${id}`, {
    method: 'DELETE',
    headers: getAdminHeaders(),
  })
  if (!res.ok) throw new Error('刪除作品失敗')
  return res.json()
}
